import { useNavigate } from "react-router-dom";
import { ArrowRight, Star, KeyRound } from "lucide-react";

const HERO = "/img/hero-firenze-duomo.jpg";

export const HeroImmersive = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden min-h-[640px] flex items-center" data-testid="hero-immersive">
      <img src={HERO} alt="Firenze e le colline toscane" className="absolute inset-0 w-full h-full object-cover object-[center_60%]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0E1C2E] via-[#0E1C2E]/85 to-[#0E1C2E]/25" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 w-full">
        <div className="max-w-4xl animate-fade-up">
          <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md text-white px-4 py-1.5 rounded-full text-xs font-semibold border border-white/15">
            <Star className="w-3.5 h-3.5 text-[#F5A623] fill-[#F5A623]" /> Il tuo riferimento di fiducia a Scandicci e Firenze
          </span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] mt-6 text-white">
            Verso la nuova<br />concezione di <span className="text-[#6FB3EC]">Casa.</span>
          </h1>
          <p className="text-lg text-white/80 mt-5 max-w-2xl leading-relaxed">
            Agenzia immobiliare, studio tecnico e amministrazioni condominiali a Scandicci e Firenze: un unico team di fiducia con tutte le competenze professionali per seguirti dalla compravendita alla ristrutturazione, fino alla gestione del tuo condominio.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap lg:flex-nowrap gap-3 mt-8">
            <button onClick={() => navigate("/preventivo-condominio")} className="bg-[#2472C8] hover:bg-[#1E5FA6] text-white font-bold px-5 py-3.5 rounded-full flex items-center justify-center gap-2 transition-colors whitespace-nowrap text-[15px]" data-testid="hero-cta-condominio">
              Richiedi preventivo condominio <ArrowRight className="w-5 h-5 shrink-0" />
            </button>
            <button onClick={() => navigate("/valuta-la-tua-casa")} className="bg-[#F5A623] hover:bg-[#E0961C] text-[#1B2A41] font-bold px-5 py-3.5 rounded-full flex items-center justify-center gap-2 transition-colors whitespace-nowrap text-[15px]" data-testid="hero-cta-valuta">
              Valuta gratis la tua casa <ArrowRight className="w-5 h-5 shrink-0" />
            </button>
            <button onClick={() => navigate("/studio-tecnico/")} className="bg-white hover:bg-white/90 text-[#1B2A41] font-bold px-5 py-3.5 rounded-full flex items-center justify-center gap-2 transition-colors whitespace-nowrap text-[15px]" data-testid="hero-cta-consulenza">
              Chiedi una consulenza tecnica <ArrowRight className="w-5 h-5 shrink-0" />
            </button>
          </div>

          <a href="https://www.miocondominio.eu/" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/15 hover:bg-white/15 text-white rounded-2xl px-5 py-3.5 transition-colors" data-testid="hero-area-riservata">
            <KeyRound className="w-5 h-5 text-[#F5A623] shrink-0" />
            <span className="text-sm"><strong className="font-semibold">Sei già condòmino?</strong> Accedi alla tua area riservata</span>
            <ArrowRight className="w-4 h-4 ml-auto shrink-0" />
          </a>
        </div>
      </div>
    </section>
  );
};
